export default __webpack_public_path__ + "logo.42a270274494df18d20ac5c14a7246a3.png";